import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { View } from '@olxbr/design-system'

import HRule from '../../atoms/HRule'
import TextCallout from '../../molecules/TextCallout'
import ScrollView from '../../atoms/ScrollView'
import Paper from '../../atoms/Paper'
import LogoTitle from '../../molecules/LogoTitle'
import ForgotPasswordTemplate from '../../templates/ForgotPasswordTemplate'
import medias from '../../../util/medias'
import Lurker from '../../../util/lurker'

const lurker = new Lurker('forgot_password')

const Content = styled(View)`
  display: flex;
  flex-direction: column;
  margin: ${() => '64px auto'};
  max-width: 466px;
  ${medias.medium`
    margin: 0;
  `}
`

const HRuleWrapper = styled(View)`
  margin-top: 34px;
  margin-right: 0;
  margin-bottom: 28px;
  margin-left: 0;
`

const Title = styled.span.attrs({ className: 'typo-body-large' })`
  text-align: center;
  font-size: 20px;
  margin-top: var(--spacing-3);
  font-weight: var(--font-weight-semibold);
`

const PaperWrapper = styled(Paper)`
  border: 1px solid var(--color-neutral-90);
`

export const ForgotPasswordPage = props => {
  const { onSuccess, onSubmit, onError, showAccountNotFoundTest, onRegisterClick, abTests } = props
  return (
    <ScrollView>
      <Content>
        <PaperWrapper abTests={abTests}>
          <LogoTitle>
            <Title>Qual o e-mail da conta?</Title>
          </LogoTitle>

          <ForgotPasswordTemplate
            onSuccess={onSuccess}
            onSubmit={onSubmit}
            onError={onError}
            showAccountNotFoundTest={showAccountNotFoundTest}
            onRegisterClick={onRegisterClick}
            abTests={abTests}
          />
          <HRuleWrapper>
            <HRule />
          </HRuleWrapper>
          <TextCallout
            text="Voltar para"
            linkText="Entrar"
            href="/acesso"
            onClick={() => lurker.clickEvt('back_to_login')}
            preventHrefOnClick={false}
          />
        </PaperWrapper>
      </Content>
    </ScrollView>
  )
}

ForgotPasswordPage.propTypes = {
  onSuccess: PropTypes.func,
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
  onRegisterClick: PropTypes.func,
  showAccountNotFoundTest: PropTypes.bool,
  abTests: PropTypes.string,
}
